<template>
    <div class="container-fluid py-3">
        <div class="card shadow-sm">
            <div class="card-header pb-0 d-flex align-items-center justify-content-between flex-wrap gap-2">
                <div class="d-flex align-items-center gap-2">
                    <span class="cal-header-icon cal-header-icon--blue">
                        <i class="bi bi-file-earmark-text-fill"></i>
                    </span>
                    <div>
                        <h6 class="mb-0 fw-bold font-weight-bolder">Müqavilələr siyahısı</h6>
                        <small class="text-muted" style="font-size: 0.78rem;">Həyat sığortası üzrə bağlanmış müqavilələr</small>
                    </div>
                </div>
                <div class="d-flex align-items-center gap-2">
                    <button type="button" @click="NewContract()" class="btn action-btn action-btn--success">
                        <i class="bi bi-plus-lg me-1"></i>
                        <span>Yeni müqavilə</span>
                    </button>
                    <button type="button" class="btn action-btn action-btn--muted" @click="GetQuotas()">
                        <i class="bi bi-arrow-clockwise me-1"></i>
                        <span>Yeniləmək</span>
                    </button>
                    <button
                        type="button"
                        @click="showFilter = !showFilter"
                        class="btn action-btn"
                        :class="showFilter ? 'action-btn--info' : 'action-btn--muted'"
                        title="Filter"
                    >
                        <i class="bi bi-funnel-fill"></i>
                    </button>
                </div>
            </div>

            <div class="card-body">
                <transition name="slide">
                    <div class="filter-panel-card mb-4 p-3 rounded" v-show="showFilter">
                        <div class="row align-items-end g-3">
                            <div class="col-sm-6 col-md-3 col-lg-2">
                                <label class="form-label mb-1">Status</label>
                                <el-select v-model="status" placeholder="Seçin" class="w-100">
                                    <el-option label="Bütün" :value="-1" />
                                    <el-option label="Qüvvədə olanlar" :value="0" />
                                    <el-option label="Qüvvədən düşmüşlər" :value="1" />
                                    <el-option label="Gözlənilənlər" :value="2" />
                                </el-select>
                            </div>
                            <div class="col-sm-6 col-md-4 col-lg-4">
                                <label class="form-label mb-1">Tarix aralığı</label>
                                <div class="d-flex align-items-center gap-2">
                                    <el-date-picker format="DD.MM.YYYY" :disabled-date="DisableStartDate"
                                        v-model="date1" type="date" class="w-50" placeholder="Başlanğıc" />
                                    <el-date-picker format="DD.MM.YYYY" :disabled-date="DisableEndDate"
                                        v-model="date2" type="date" class="w-50" placeholder="Son" />
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-5 col-lg-6">
                                <div class="app-search-form-group">
                                    <el-input
                                        v-model="srcText"
                                        placeholder="Tam adı / VÖEN / Müqavilə nömrəsi"
                                        clearable
                                        class="app-search-input"
                                        @keydown.enter="GetQuotas()"
                                    />
                                    <button type="button" @click="GetQuotas()" class="btn app-search-btn">
                                        <i class="bi bi-search"></i>
                                        <span>Axtar</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </transition>

                <div v-loading="loading">
                    <Table @get-data="GetQuotas" :data="data" :showFilter="showFilter"></Table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Table from "./Components/Table.vue";
import dayjs from 'dayjs';

export default {
    components: {
        Table
    },
    data() {
        return {
            loading: null,
            srcText: null,
            data: [
                {
                    issued: true,
                    policyId: 2001,
                    policyFullNumber: "KM-2025-000101",
                    policyStatusName: "Aktiv",
                    contractDateStr: "01.01.2025",
                    insured: { name: "ABC MMC" },
                    startDateStr: "01.01.2025",
                    endDateStr: "31.12.2025",
                    cancelDateStr: "",
                    cancelTypeName: "",
                    descr: "İlkin müqavilə"
                },
                {
                    issued: false,
                    policyId: 2002,
                    policyFullNumber: "KM-2025-000102",
                    policyStatusName: "Dayandırılıb",
                    contractDateStr: "15.02.2025",
                    insured: { name: "XYZ MMC" },
                    startDateStr: "15.02.2025",
                    endDateStr: "14.02.2026",
                    cancelDateStr: "01.05.2025",
                    cancelTypeName: "Müştəri tələbi ilə",
                    descr: "Əlavə şərtlərlə dayandırılıb"
                },
                {
                    issued: true,
                    policyId: 2003,
                    policyFullNumber: "KM-2025-000103",
                    policyStatusName: "Aktiv",
                    contractDateStr: "20.03.2025",
                    insured: { name: "MegaTech MMC" },
                    startDateStr: "20.03.2025",
                    endDateStr: "19.03.2026",
                    cancelDateStr: "",
                    cancelTypeName: "",
                    descr: ""
                },
                {
                    issued: true,
                    policyId: 2004,
                    policyFullNumber: "KM-2025-000104",
                    policyStatusName: "Aktiv",
                    contractDateStr: "05.04.2025",
                    insured: { name: "Delta MMC" },
                    startDateStr: "05.04.2025",
                    endDateStr: "04.04.2026",
                    cancelDateStr: "",
                    cancelTypeName: "",
                    descr: "Əlavə bonuslar"
                },
                {
                    issued: false,
                    policyId: 2005,
                    policyFullNumber: "KM-2025-000105",
                    policyStatusName: "Dayandırılıb",
                    contractDateStr: "10.05.2025",
                    insured: { name: "Nova MMC" },
                    startDateStr: "10.05.2025",
                    endDateStr: "09.05.2026",
                    cancelDateStr: "20.06.2025",
                    cancelTypeName: "Müştəri tələbi ilə",
                    descr: ""
                },
                {
                    issued: true,
                    policyId: 2006,
                    policyFullNumber: "KM-2025-000106",
                    policyStatusName: "Aktiv",
                    contractDateStr: "12.06.2025",
                    insured: { name: "Gamma MMC" },
                    startDateStr: "12.06.2025",
                    endDateStr: "11.06.2026",
                    cancelDateStr: "",
                    cancelTypeName: "",
                    descr: ""
                },
                {
                    issued: true,
                    policyId: 2007,
                    policyFullNumber: "KM-2025-000107",
                    policyStatusName: "Aktiv",
                    contractDateStr: "01.07.2025",
                    insured: { name: "Omega MMC" },
                    startDateStr: "01.07.2025",
                    endDateStr: "30.06.2026",
                    cancelDateStr: "",
                    cancelTypeName: "",
                    descr: "Əlavə xidmətlər"
                },
                {
                    issued: false,
                    policyId: 2008,
                    policyFullNumber: "KM-2025-000108",
                    policyStatusName: "Dayandırılıb",
                    contractDateStr: "18.07.2025",
                    insured: { name: "Sigma MMC" },
                    startDateStr: "18.07.2025",
                    endDateStr: "17.07.2026",
                    cancelDateStr: "01.08.2025",
                    cancelTypeName: "Sığortaçı xitamı",
                    descr: ""
                },
                {
                    issued: true,
                    policyId: 2009,
                    policyFullNumber: "KM-2025-000109",
                    policyStatusName: "Aktiv",
                    contractDateStr: "05.08.2025",
                    insured: { name: "Alpha MMC" },
                    startDateStr: "05.08.2025",
                    endDateStr: "04.08.2026",
                    cancelDateStr: "",
                    cancelTypeName: "",
                    descr: ""
                },
                {
                    issued: true,
                    policyId: 2010,
                    policyFullNumber: "KM-2025-000110",
                    policyStatusName: "Aktiv",
                    contractDateStr: "20.08.2025",
                    insured: { name: "Beta MMC" },
                    startDateStr: "20.08.2025",
                    endDateStr: "19.08.2026",
                    cancelDateStr: "",
                    cancelTypeName: "",
                    descr: ""
                },
                {
                    issued: false,
                    policyId: 2011,
                    policyFullNumber: "KM-2025-000111",
                    policyStatusName: "Dayandırılıb",
                    contractDateStr: "01.09.2025",
                    insured: { name: "Theta MMC" },
                    startDateStr: "01.09.2025",
                    endDateStr: "31.08.2026",
                    cancelDateStr: "15.09.2025",
                    cancelTypeName: "Müştəri tələbi ilə",
                    descr: ""
                },
                {
                    issued: true,
                    policyId: 2012,
                    policyFullNumber: "KM-2025-000112",
                    policyStatusName: "Aktiv",
                    contractDateStr: "15.09.2025",
                    insured: { name: "Epsilon MMC" },
                    startDateStr: "15.09.2025",
                    endDateStr: "14.09.2026",
                    cancelDateStr: "",
                    cancelTypeName: "",
                    descr: "Yeni müqavilə"
                }
            ],
            dialogVis: false,
            status: 0,
            date1: new Date(new Date().setFullYear(new Date().getFullYear() - 2)).toISOString().split("T")[0],
            date2: new Date(),
            showFilter: true,
            companyName: null
        }
    },
    methods: {
        DisableStartDate(date) {
            return this.date2 && dayjs(date).isAfter(dayjs(this.date2), 'day')
        },
        DisableEndDate(date) {
            return this.date1 && dayjs(date).isBefore(dayjs(this.date1), 'day')
        },
        NewContract() {
            window.open(window.location.origin + '/documents/contract', "_blank");
        },
        GetQuotas() {

        }
    },
    mounted() {
        this.GetQuotas()
    }
}
</script>